import * as ActionTypes from 'redux/actionTypes'
import ImmutabilityUtil from 'utils/ImmutabilityUtil';
import DSBriefModel from 'models/DSBriefModel';

const initialState = {
    productConfig: null,

    selectedProduct: null,
    multiselectedProducts: DSBriefModel.socialMediaDesignsRequested ? DSBriefModel.socialMediaDesignsRequested.map(designRequested => designRequested.Type) : ["noSelection"],
    selectedProductConfigurationsMap: new Map(), // pfid -> ProductConfig[]
    uploads: DSBriefModel.uploads,
    uploadRefs: DSBriefModel.uploadRefs,
    selectedTimezone: null,
    selectedDate: null,
    selectedTime: null,
    note: DSBriefModel.note,
    name: '',
    email: '',
    phone: '',
    size: '',
    socialMediaLink: '',
    selectedProductError: null,
    noteError: null,
    nameError: null,
    emailError: null,
    phoneError: null,
    noteErrorsSuppressed: true,
    nameErrorsSuppressed: true,
    emailErrorsSuppressed: true,
    phoneErrorsSuppressed: true,
    coDesignSelected: DSBriefModel.designLivePreSelected,

    availableDates: [],
    availableDatesLoading: true,
    setAvailableDatesError: null,
    availableTimes: [],
    availableTimesLoading: true,
    setAvailableTimesError: null,
    orderSubmitting: false,
    submitCoDesignOrderError: null,
    submitDifyOrderError: null,    
    saveDifyOrderError: null,
    previousDesigners: DSBriefModel.previousDesigners, 
    selectedDesigner: null,
    socialMediaTemplateDocId: (DSBriefModel.socialMediaDesignsRequested && DSBriefModel.socialMediaDesignsRequested.length > 0) ? DSBriefModel.socialMediaDesignsRequested[0].DocId : null,

    documentPagePreviewModalVisible: false,
    documentPagePreviewModalDocumentPage: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_SELECTED_PRODUCT:
            return {
                ...state,
                selectedProduct: action.selectedProduct,
                selectedProductError: null,
            };
        case ActionTypes.SET_MULTISELECTED_PRODUCTS:
            return {
                ...state,
                multiselectedProducts: action.multiselectedProducts,
                selectedProductError: null,
            };
        case ActionTypes.SET_SELECTED_PRODUCT_CONFIGURATIONS:
            return {
                ...state,
                selectedProductConfigurationsMap: ImmutabilityUtil.setValueInMap(state.selectedProductConfigurationsMap, action.pfid, action.selectedProductConfigurations),
            };
        case ActionTypes.REMOVE_SELECTED_PRODUCT_CONFIGURATION:
            return {
                ...state,
                selectedProductConfigurationsMap: ImmutabilityUtil.updateValueInMap(
                    state.selectedProductConfigurationsMap,
                    action.pfid,
                    (currentSelectedProductConfigurations) => {
                        if (currentSelectedProductConfigurations === undefined) {
                            return [];
                        }

                        return currentSelectedProductConfigurations.filter(productConfiguration => productConfiguration.id !== action.selectedProductConfigurationId);
                    }
                ),
            };
        case ActionTypes.ADD_UPLOAD:
            return {
                ...state,
                uploads: [...state.uploads, action.uploadId],
                uploadRefs: {...state.uploadRefs, [action.uploadId]: action.uploadUrl },
            };
        case ActionTypes.REMOVE_UPLOAD:
            return {
                ...state,
                uploads: state.uploads.filter(uploadId => uploadId !== parseInt(action.uploadId, 10)),
                uploadRefs: Object.keys(state.uploadRefs).reduce(function (filtered, key) {
                    if (key !== action.uploadId) filtered[key] = state.uploadRefs[key];
                    return filtered;
                }, {}),
            };
        case ActionTypes.SET_SELECTED_DESIGNER:
            return {
                ...state,
                selectedDesigner: action.selectedDesigner,
            }
        case ActionTypes.SET_SELECTED_TIMEZONE:
            return {
                ...state,
                selectedTimezone: action.selectedTimezone,
                // clear dates and times when the timezone changes
                availableDates: [],
                availableTimes: [],
            };
        case ActionTypes.SET_SELECTED_DATE:
            return {
                ...state,
                selectedDate: action.selectedDate,
                selectedTime: null, // clear time when a new date is selected
            };
        case ActionTypes.SET_SELECTED_TIME:
            return {
                ...state,
                selectedTime: action.selectedTime,
            };
        case ActionTypes.SET_NOTE:
            return {
                ...state,
                note: action.note,
            };
        case ActionTypes.SET_SIZE:
            return {
                ...state,
                size: action.size,
            };
        case ActionTypes.SET_SOCIAL_MEDIA_LINK:
            return {
                ...state,
                socialMediaLink: action.socialMediaLink,
            };
        case ActionTypes.SET_NAME:
            return {
                ...state,
                name: action.name,
            };
        case ActionTypes.SET_EMAIL:
            return {
                ...state,
                email: action.email,
            };
        case ActionTypes.SET_PHONE:
            return {
                ...state,
                phone: action.phone,
            };
        case ActionTypes.SET_SELECTED_PRODUCT_ERROR:
            return {
                ...state,
                selectedProductError: action.selectedProductError,
            };
        case ActionTypes.SET_NOTE_ERROR:
            return {
                ...state,
                noteError: action.noteError,
            };
        case ActionTypes.SET_SIZE_ERROR:
            return {
                ...state,
                sizeError: action.sizeError,
            };
        case ActionTypes.SET_NAME_ERROR:
            return {
                ...state,
                nameError: action.nameError,
            };
        case ActionTypes.SET_EMAIL_ERROR:
            return {
                ...state,
                emailError: action.emailError,
            };
        case ActionTypes.SET_PHONE_ERROR:
            return {
                ...state,
                phoneError: action.phoneError,
            };
        case ActionTypes.SET_NOTE_ERRORS_SUPPRESSED:
            return {
                ...state,
                noteErrorsSuppressed: action.noteErrorsSuppressed,
            };
        case ActionTypes.SET_SIZE_ERRORS_SUPPRESSED:
            return {
                ...state,
                sizeErrorsSuppressed: action.sizeErrorsSuppressed,
            };
        case ActionTypes.SET_NAME_ERRORS_SUPPRESSED:
            return {
                ...state,
                nameErrorsSuppressed: action.nameErrorsSuppressed,
            };
        case ActionTypes.SET_EMAIL_ERRORS_SUPPRESSED:
            return {
                ...state,
                emailErrorsSuppressed: action.emailErrorsSuppressed,
            };
        case ActionTypes.SET_PHONE_ERRORS_SUPPRESSED:
            return {
                ...state,
                phoneErrorsSuppressed: action.phoneErrorsSuppressed,
            };
        case ActionTypes.SET_CO_DESIGN_SELECTED:
            return {
                ...state,
                coDesignSelected: action.coDesignSelected,
            };
        case ActionTypes.SET_DOCUMENT_PAGE_PREVIEW_MODAL_VISIBLE:
            return {
                ...state,
                documentPagePreviewModalVisible: action.documentPagePreviewModalVisible,
            };   
        case ActionTypes.SET_DOCUMENT_PAGE_PREVIEW_MODAL_DOCUMENT_PAGE:
            return {
                ...state,
                documentPagePreviewModalDocumentPage: action.documentPagePreviewModalDocumentPage,
            };
        case ActionTypes.SET_AVAILABLE_DATES_SUCCESS:
            return {
                ...state,
                availableDates: action.availableDates,
                // set selected date to the first date in the new list
                selectedDate: action.availableDates.length > 0 ? action.availableDates[0] : null,
                // remove loading status and error message
                availableDatesLoading: false,
                setAvailableDatesError: null,
            };
        case ActionTypes.SET_AVAILABLE_DATES_FAILURE:
            return {
                ...state,
                setAvailableDatesError: action.error,
                availableDatesLoading: false,
            };
        case ActionTypes.SET_AVAILABLE_DATES_LOADING:
            return {
                ...state,
                availableDatesLoading: action.loading,
            };
        case ActionTypes.SET_AVAILABLE_TIMES_SUCCESS:
            return {
                ...state,
                availableTimes: action.availableTimes,
                // set selected time to the first time in the new list
                selectedTime: action.availableTimes.length > 0 ? action.availableTimes[0] : null,
                // remove loading status and error message
                availableTimesLoading: false,
                setAvailableTimesError: null,
            };
        case ActionTypes.SET_AVAILABLE_TIMES_FAILURE:
            return {
                ...state,
                setAvailableTimesError: action.error,
                availableTimesLoading: false,
            };
        case ActionTypes.SET_AVAILABLE_TIMES_LOADING:
            return {
                ...state,
                availableTimesLoading: action.loading,
            };
        case ActionTypes.SET_ORDER_SUBMITTING:
            return {
                ...state,
                orderSubmitting: action.orderSubmitting,
            };
        case ActionTypes.SUBMIT_CO_DESIGN_ORDER_SUCCESS:
            return {
                ...state,
                orderSubmitting: false,
                submitCoDesignOrderError: null,
            };
        case ActionTypes.SUBMIT_DIFY_ORDER_SUCCESS:
            return {
                ...state,
                orderSubmitting: false,
                submitDifyOrderError: null,
            };
        case ActionTypes.SUBMIT_CO_DESIGN_ORDER_FAILURE:
            return {
                ...state,
                submitCoDesignOrderError: action.error,
                orderSubmitting: false,
            };
        case ActionTypes.SUBMIT_DIFY_ORDER_FAILURE:
            return {
                ...state,
                submitDifyOrderError: action.error,
                orderSubmitting: false,
            };
        case ActionTypes.SAVE_DIFY_ORDER_SUCCESS:
            return {
                ...state,
                saveDifyOrderError: null,
                orderSubmitting: false,
     
            };
        case ActionTypes.SAVE_DIFY_ORDER_FAILURE:
            return {
                ...state,
                saveDifyOrderError: action.error,
                orderSubmitting: false,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducer.js